import React, { Component } from "react";

// Assets
import PenIcon from "../../Assets/Pen.svg";
import TickMarkIcon from "../../Assets/TickMark.svg";
import EyeIcon from "../../Assets/eye.svg";
import EyeCloseIcon from "../../Assets/eyeClose.svg";

// Profile Component
export default class PersonalInfo extends Component {
  // constructor function
  constructor(props) {
    super(props);

    this.state = {
      // state to store user name, password and email
      userName: "Prathamesh Revan Vibhute",
      email: "prathuvibhute3110@gmail.com",
      password: "popul@rduck",
      hiddenPassword: null,

      // state to check button status if true PenIcon button is displayed clicked, false shows TickMark button
      userNameClick: true,
      emailClick: true,
      passwordClick: true,
      eyeClick: true,
    };
  }

  // Event Handler to Handler Button Click which updates button status present in state
  onButtonClick = (e, inputType) => {
    e.preventDefault();

    if (inputType === 1) {
      if (this.state.userNameClick) this.setState({ userNameClick: false });
      else this.setState({ userNameClick: true });
    } else if (inputType === 2) {
      if (this.state.emailClick) this.setState({ emailClick: false });
      else this.setState({ emailClick: true });
    } else {
      if (this.state.passwordClick) this.setState({ passwordClick: false });
      else this.setState({ passwordClick: true });
    }

    // Profile Title Change Logic
    if (inputType === 1) {
      if (this.state.userNameClick === false)
        this.props.onTitleChange(this.props.name);
    }
  };

  // userInputField Function
  // inputType = 1 is Name,inputType = 2 is  Mail and inputType = 2 is for Password
  userInputField(labelName, textValue, click, inputType) {
    // Mail & User Input Code
    if (inputType === 1 || inputType === 2) {
      return (
        <div className="Profile_UserInputBlock">
          <form
            onSubmit={(e) => {
              this.state.onInputSubmitted(e);
            }}
          >
            <div className="Profile_InputField">
              <div className="Profile_InputFieldText">
                <label className="Profile_InputFieldLabel">{labelName}</label>

                {/* Switch Input Field Condition*/}
                {click ? (
                  <p className="Profile_Text">{textValue}</p>
                ) : (
                  <div>
                    <input
                      type={inputType === 1 ? "text" : "email"}
                      className="Profile_UserInputText"
                      placeholder={
                        inputType === 1
                          ? "Enter Your User Name"
                          : "Enter Your Email"
                      }
                      onKeyPress={(event) =>
                        event.key === " " ? event.preventDefault() : true
                      }
                      onChange={(e) => this.props.onInputChange(e, inputType)}
                      pattern="Please Enter Valid Email ID"
                      required
                    />
                  </div>
                )}
              </div>

              {/* Switch Button Condition*/}
              {click ? (
                <button
                  className="Profile_InputFieldButton"
                  style={{ backgroundImage: `url(${PenIcon})` }}
                  onClick={(e) => this.onButtonClick(e, inputType)}
                ></button>
              ) : (
                <button
                  className="Profile_InputFieldButton"
                  style={{ backgroundImage: `url(${TickMarkIcon})` }}
                  onClick={(e) => this.onButtonClick(e, inputType)}
                ></button>
              )}
            </div>
          </form>
        </div>
      );

      // Else Password Input Code
    } else {
      return (
        <div className="Profile_UserInputBlock">
          <form>
            <div className="Profile_InputField">
              <div className="Profile_InputFieldText" style={{ width: `85%` }}>
                <label className="Profile_InputFieldLabel">{labelName}</label>

                {/* Switch Input Field Condition*/}
                {click ? (
                  <p className="Profile_Text">
                    {this.state.eyeClick
                      ? this.state.password
                      : this.state.hiddenPassword}
                  </p>
                ) : (
                  <div>
                    <input
                      type="password"
                      className="Profile_UserInputText"
                      placeholder={"Enter Your Password"}
                      required
                      onKeyPress={(event) =>
                        event.key === " " ? event.preventDefault() : true
                      }
                      onChange={(e) => this.props.onInputChange(e, inputType)}
                    />
                  </div>
                )}
              </div>

              {/* Eye Button*/}
              <button
                className="Profile_InputFieldButton"
                style={
                  this.state.eyeClick
                    ? {
                        backgroundImage: `url(${EyeIcon})`,
                        marginRight: `2%`,
                        marginLeft: "2%",
                        backgroundPosition: "center",
                      }
                    : {
                        backgroundImage: `url(${EyeCloseIcon})`,
                        marginRight: `2%`,
                        marginLeft: "2%",
                        backgroundPosition: "center",
                      }
                }
                onClick={(e) => {
                  this.props.onPasswordHide(e);
                }}
              ></button>

              {/* Switch Button Condition */}
              {click ? (
                <button
                  className="Profile_InputFieldButton"
                  style={{ backgroundImage: `url(${PenIcon})` }}
                  onClick={(e) => this.onButtonClick(e, inputType)}
                ></button>
              ) : (
                <button
                  type="submit"
                  className="Profile_InputFieldButton"
                  style={{ backgroundImage: `url(${TickMarkIcon})` }}
                  onClick={(e) => this.onButtonClick(e, inputType)}
                ></button>
              )}
            </div>
          </form>
        </div>
      );
    }
  }

  render() {
    return (
      <>
        {/* Personal Information Block */}
        <div className="Profile_PersonalInfo_Component">
          <div className="Profile_PITitle">Personal Information</div>
          <div className="Profile_PICard">
            {this.userInputField(
              "Device Name",
              this.props.name,
              this.state.userNameClick,
              1
            )}
            {this.userInputField(
              "Mail",
              this.props.email,
              this.state.emailClick,
              2
            )}
            {this.userInputField(
              "Password",
              this.props.password,
              this.state.passwordClick,
              3
            )}
          </div>
        </div>
      </>
    );
  }
}
